import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="dependent-checkboxes"
export default class extends Controller {
  static targets = ["child", "parent"];
  connect() {
    console.log("connected", this.childTarget, this.parentTarget);
  }

  childChanged() {
    if (this.childTarget.checked) {
      this.parentTarget.checked = true;
    }
  }

  parentChanged() {
    if (!this.parentTarget.checked) {
      this.childTarget.checked = false;
    }
  }
}
